import { render, staticRenderFns } from "./AttachementsSelector.vue?vue&type=template&id=0b36b9d0&scoped=true"
import script from "./AttachementsSelector.vue?vue&type=script&lang=js"
export * from "./AttachementsSelector.vue?vue&type=script&lang=js"
import style0 from "./AttachementsSelector.vue?vue&type=style&index=0&id=0b36b9d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b36b9d0",
  null
  
)

export default component.exports